import axios from 'axios'

import { API_BASE, apiErrorHandler } from '../api'
import Auth from '../auth'

const MESSAGE_TEMPLATES_ENDPOINT = `${API_BASE}message-templates/`

export default class MessageTemplateAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new MessageTemplateAPI(cls)
  }

  list(targetLanguage) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    if (targetLanguage) {
      const components = targetLanguage.split('-')
      const hasLocale = components.length >= 2
      const headerVal = hasLocale
        ? `${targetLanguage},${components[0]};q=0.9`
        : `${targetLanguage};q=0.9`

      options.headers['Accept-Language'] = headerVal
    }

    const promise = axios
      .get(`${MESSAGE_TEMPLATES_ENDPOINT}`, options)
      .then(response => response.data)
      .then(data => {
        return {
          ...data,
          results: data.results.map(this.cls.fromAPI),
        }
      })
      .catch(
        apiErrorHandler({
          apiName: 'List Message Templates API error',
          rethrowErrors: true,
        }),
      )
    return promise
  }
}
